export default __webpack_public_path__ + "static/media/image-1.79d3cd09.png";